module.exports = __webpack_public_path__ + "static/media/back-btn.9f7ebfa5.svg";